import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  IconButton,
} from '@mui/material';
import {
  CloudUpload,
  Delete,
  Image as ImageIcon,
} from '@mui/icons-material';

export default function MaterialImageUpload({ 
  label = "Upload Image", 
  inputProps, 
  small = false,
  subLabel = false 
}) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(selectedFile);
    }
    
    // Call the original onChange handler if provided
    if (inputProps?.onChange) {
      inputProps.onChange(event);
    }
  };

  const handleRemove = () => {
    setFile(null);
    setPreview(null);
    // Reset the file input
    const input = document.getElementById(`image-upload-${inputProps?.name}`);
    if (input) input.value = '';
  };

  return (
    <Box>
      {label && (
        <Typography variant="subtitle2" gutterBottom>
          {label}
        </Typography>
      )}
      {subLabel && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {subLabel}
        </Typography>
      )}
      
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          textAlign: 'center',
          border: '2px dashed',
          borderColor: 'grey.300',
          backgroundColor: 'grey.50',
          minHeight: small ? 120 : 200,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'primary.50',
          },
        }}
      >
        {preview ? (
          <Box sx={{ position: 'relative', width: '100%' }}>
            <img
              src={preview}
              alt="Preview"
              style={{
                width: '100%',
                maxWidth: small ? 150 : 300,
                height: 'auto',
                borderRadius: '8px',
                maxHeight: small ? 100 : 200,
                objectFit: 'cover',
              }}
            />
            <IconButton
              onClick={handleRemove}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.7)',
                },
              }}
              size="small"
            >
              <Delete fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Box>
            <ImageIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {file ? file.name : 'No image selected'}
            </Typography>
            <Button
              component="label"
              variant="outlined"
              startIcon={<CloudUpload />}
              sx={{ mt: 1 }}
            >
              Choose Image
              <input
                {...inputProps}
                type="file"
                id={`image-upload-${inputProps?.name}`}
                hidden
                onChange={handleFileChange}
                accept="image/*"
                multiple={false}
              />
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
